import React, { useMemo } from 'react';
import Stack from '@gogame/ui/Stack';
import Actions, { Action } from '@gogame/ui/Actions';
import { NoResults } from '@gogame/ui/NoResults';
import { Help } from '@gogame/ui/Help';
import { makeStyles } from '@gogame/ui/styles';
import {
  PlaylistRemoveIcon,
  HighlightOffIcon,
  EditIcon,
} from '@gogame/ui/Icon';

import ListToolbar from '../ListToolbar';
import { SortableVirtualizedList } from '../../VirtualizedList';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '400px',
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
}));

const DefaultSelectedSecondaryActionHelpRenderer = ({ option }) => {
  return (
    <Help key={option.tooltip} placement={'top'}>
      {option.tooltip}
    </Help>
  );
};
const SelectedMetrics = ({
  metrics = [],
  selected = [],
  onClearAll,
  onChange,
  onUpdateMetric,
  getOptionLabel,
  getOptionMetricValue,
  selectedSecondaryActionHelpRenderer:
    SelectedSecondaryActionHelpRenderer = DefaultSelectedSecondaryActionHelpRenderer,
}) => {
  const classes = useStyles();
  const selectedMetrics = useMemo(() => {
    const result = [];
    for (let i = 0; i < selected.length; i++) {
      const colName = selected[i];
      const foundMetric = metrics.find(
        (metric) => colName === getOptionMetricValue(metric)
      );
      if (foundMetric) {
        result.push(foundMetric);
      }
    }
    return result;
  }, [metrics, selected]);

  const handleReorder = (metricsOrder) => emitChange(metricsOrder);
  const empty = !metrics.length || !selected.length;

  const emitChange = (metricsOrder) =>
    onChange(metricsOrder.map(getOptionMetricValue));

  const renderSecondaryAction = (option) => (
    <Stack direction={'row'} spacing={1} alignItems={'center'}>
      {option.tooltip ? (
        <SelectedSecondaryActionHelpRenderer option={option} />
      ) : null}
      <Actions>
        {option.categoryId === 1 ? (
          <Action
            onClick={() => onUpdateMetric(option)}
            label={'Edit'}
            icon={<EditIcon />}
          />
        ) : null}
        <Action
          onClick={() =>
            emitChange(selectedMetrics.filter((m) => m !== option))
          }
          label={'Remove'}
          icon={<HighlightOffIcon />}
        />
      </Actions>
    </Stack>
  );
  const title = selectedMetrics?.length
    ? `Selected (${selectedMetrics.length})`
    : 'Selected';
  return (
    <Stack className={classes.root} flex={1}>
      <ListToolbar
        title={title}
        actions={
          // empty ? null : (
          <Actions>
            <Action
              onClick={onClearAll}
              label={'Remove all'}
              icon={<PlaylistRemoveIcon />}
            />
          </Actions>
          // )
        }
      />
      {empty ? (
        <NoResults
          inited={!!metrics || !!selected}
          noResultsLabel={'There are no selected columns'}
        />
      ) : (
        <SortableVirtualizedList
          data={selectedMetrics}
          onReorder={handleReorder}
          getOptionValue={getOptionMetricValue}
          secondaryAction={renderSecondaryAction}
          rowHeight={48}
          getOptionLabel={getOptionLabel}
          button={false}
          primaryTypographyProps={{
            disableTooltip: true,
          }}
          secondaryActionProps={{ style: { right: 4 } }}
        />
      )}
    </Stack>
  );
};

export default SelectedMetrics;
